import get from 'lodash/get';
import { getFormattedTicketTypePayloadByKeys, getFormattedTicketTypePayloadByValues } from './utils';

// Constants
export const ENTITIES_KEY_TICKET_TYPES = 'ticketTypes';

// Action constants
export const ADD_TICKET_TYPE_DATA = 'entities/ADD_TICKET_TYPE_DATA';
export const UPDATE_TICKET_TYPE = 'entities/UPDATE_TICKET_TYPE';
export const DELETE_TICKET_TYPE = 'entities/DELETE_TICKET_TYPE';

// Actions & thunks.
export const addTicketTypeData = (payload) => (dispatch, getState) => {
    const state = getState();
    const payloadWithFormattedKeys = getFormattedTicketTypePayloadByKeys(payload);
    const payloadFullyFormatted = getFormattedTicketTypePayloadByValues(payloadWithFormattedKeys);

    dispatch({
        type: ADD_TICKET_TYPE_DATA,
        payload: {
            entities: {
                [ENTITIES_KEY_TICKET_TYPES]: {
                    ...state[ENTITIES_KEY_TICKET_TYPES],
                    [payload.ticketId]: payloadFullyFormatted,
                },
            },
        },
    });
};

export const updateTicketType = (payload) => (dispatch, getState) => {
    const state = getState();
    const payloadWithFormattedKeys = getFormattedTicketTypePayloadByKeys(payload);
    const payloadFullyFormatted = getFormattedTicketTypePayloadByValues(payloadWithFormattedKeys);

    dispatch({
        type: UPDATE_TICKET_TYPE,
        payload: {
            entities: {
                [ENTITIES_KEY_TICKET_TYPES]: {
                    ...state[ENTITIES_KEY_TICKET_TYPES],
                    [payloadWithFormattedKeys.id]: {
                        ...get(state[ENTITIES_KEY_TICKET_TYPES], payloadWithFormattedKeys.id, {}),
                        ...payloadFullyFormatted,
                    },
                },
            },
        },
    });
};
